import { render } from "./LogoSmall.vue?vue&type=template&id=294ce641"
import script from "./LogoSmall.vue?vue&type=script&lang=js"
export * from "./LogoSmall.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__